import * as React from 'react';
import {
	createBrowserRouter,
} from 'react-router-dom';

/*** 引入路由界面 ***/
import Error404 from './Error404.js';
import App from '../App.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
	{
		path: '/',
		element: <App m={11} />,
		errorElement: <Error404 />,
	},
	{
		path: '/pointLocation/collects',
		element: <App m={11} />,
		errorElement: <Error404 />,
	},
	{
		path: '/pointLocation/infos',
		element: <App m={12} />,
		errorElement: <Error404 />,
	},
	{
		path: '/report/pointLocationInfo/dcim',
		element: <App m={21} />,
		errorElement: <Error404 />,
	},
	{
		path: '/log/operations',
		element: <App m={31} />,
		errorElement: <Error404 />,
	},
]);

export default BasicRouter